import { BUTTON_TYPES, BUTTON_VARIANTS } from '../../../../../../constants/button-variants';
import { useFavoritesPageContext } from '../../../../contexts/favorites-page-context';
import { useCardContext } from '../../contexts/favorites-material-card-context';
import useRemoveButton from '../../hooks/use-remove-button';
import { FavoritesMaterialCardVariationProps } from '../../types';
import MaterialAcquiredInfo from '../material-acquired-info/material-acquired-info';
import MaterialUnacquiredInfo from '../material-unacquired-info/material-unacquired-info';

type ButtonsVariantsProps = {
    downloadButtonType: BUTTON_TYPES;
    addToCartType: 'icon' | 'button';
    removeButtonType: 'icon' | 'removeOnly';
};
type MaterialPricesAndButtonsProps = FavoritesMaterialCardVariationProps & ButtonsVariantsProps;

const MaterialPricesAndButtons = (props: MaterialPricesAndButtonsProps) => {
    const {
        onAddToCartSuccess,
        shouldShowAddToCart,
        downloadButtonType,
        addToCartType,
        removeButtonType,
        internalPath,
        ...rest
    } = props;

    const removeButton = useRemoveButton();
    const { areButtonsDisabled, disableButtons, enableButtons } = useFavoritesPageContext();
    const { onRemove } = useCardContext();

    const isMaterialAcquired = Boolean(rest.item.aclId);
    const activeRemoveButtonType = removeButton.isEnabled ? removeButtonType : undefined;

    if (isMaterialAcquired) {
        return (
            <MaterialAcquiredInfo
                {...rest}
                removeButtonType={activeRemoveButtonType}
                downloadButtonType={downloadButtonType}
            />
        );
    }

    const handleAddToCartCallback = (): boolean => {
        disableButtons();

        return true;
    };

    const handleAddToCartSuccess = ({ cart }: { cart: Cart }): void => {
        removeButton.hide();
        enableButtons();
        onAddToCartSuccess({ cart });
        onRemove?.(rest.item);
    };

    const handleAddToCartError = (): void => {
        enableButtons();
    };

    return (
        <MaterialUnacquiredInfo
            {...rest}
            internalPath={internalPath}
            onAddToCartSuccess={handleAddToCartSuccess}
            onAddToCartError={handleAddToCartError}
            onAddToCartCallback={handleAddToCartCallback}
            isAddToCartButtonDisabled={areButtonsDisabled}
            addToCartButtonClassNames={BUTTON_VARIANTS.YELLOW}
            showAddToCart={shouldShowAddToCart}
            addToCartType={addToCartType}
            removeButtonType={activeRemoveButtonType}
        />
    );
};

export default MaterialPricesAndButtons;
